/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesPaymentType } from './WebApiModelsEnumerationTypesPaymentType';
import {
    WebApiModelsEnumerationTypesPaymentTypeFromJSON,
    WebApiModelsEnumerationTypesPaymentTypeFromJSONTyped,
    WebApiModelsEnumerationTypesPaymentTypeToJSON,
} from './WebApiModelsEnumerationTypesPaymentType';
import type { WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItem } from './WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItem';
import {
    WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItemFromJSON,
    WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItemFromJSONTyped,
    WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItemToJSON,
} from './WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItem';

/**
 * 
 * @export
 * @interface WebApiIntegrationsDtoCreatePaymentLinkDto
 */
export interface WebApiIntegrationsDtoCreatePaymentLinkDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreatePaymentLinkDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoCreatePaymentLinkDto
     */
    memberId?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoCreatePaymentLinkDto
     */
    amount?: number;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesPaymentType}
     * @memberof WebApiIntegrationsDtoCreatePaymentLinkDto
     */
    paymentType?: WebApiModelsEnumerationTypesPaymentType;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreatePaymentLinkDto
     */
    connectedYear?: string | null;
    /**
     * 
     * @type {Array<WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItem>}
     * @memberof WebApiIntegrationsDtoCreatePaymentLinkDto
     */
    items?: Array<WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItem> | null;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoCreatePaymentLinkDto interface.
 */
export function instanceOfWebApiIntegrationsDtoCreatePaymentLinkDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoCreatePaymentLinkDtoFromJSON(json: any): WebApiIntegrationsDtoCreatePaymentLinkDto {
    return WebApiIntegrationsDtoCreatePaymentLinkDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoCreatePaymentLinkDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoCreatePaymentLinkDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
        'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'paymentType': !exists(json, 'paymentType') ? undefined : WebApiModelsEnumerationTypesPaymentTypeFromJSON(json['paymentType']),
        'connectedYear': !exists(json, 'connectedYear') ? undefined : json['connectedYear'],
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItemFromJSON)),
    };
}

export function WebApiIntegrationsDtoCreatePaymentLinkDtoToJSON(value?: WebApiIntegrationsDtoCreatePaymentLinkDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'memberId': value.memberId,
        'amount': value.amount,
        'paymentType': WebApiModelsEnumerationTypesPaymentTypeToJSON(value.paymentType),
        'connectedYear': value.connectedYear,
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(WebApiPaymentRepositoryPingPaymentsDtoPaymentLinkPaymentLinkItemToJSON)),
    };
}

